import {
  defaultMobilePaymentFormState,
  mobilePaymentFields,
} from "./mobile-payment";
import { partnerFormState, partnerPaymentFields } from "./partner-payment";
import {
  defaultTherapistClientFormState,
  therapistClientPaymentFields,
} from "./therapist-client-payment";
import { defaultWebPaymentFormState, webPaymentFields } from "./web-payment";

// Forms
const PAYMENT_FORMS = {
  mobile: "mobileForm",
  web: "webForm",
  therapistClient: "therapistClientForm",
  partner: "partnerForm",
};

export {
  PAYMENT_FORMS,
  defaultMobilePaymentFormState,
  mobilePaymentFields,
  partnerFormState,
  partnerPaymentFields,
  defaultTherapistClientFormState,
  therapistClientPaymentFields,
  defaultWebPaymentFormState,
  webPaymentFields,
};
